import { useCallback, useRef } from 'react';

export type EaseFunction = (x: number) => number;
export const easeOutQuart: EaseFunction = (x) => 1 - Math.pow(1 - x, 4);

export type ScaleFunction = (dt: number) => number;
const defaultScale: ScaleFunction = (dt) => {
  const x = Math.min(dt / 3000, 1);
  const y = easeOutQuart(x);
  return (1 - y) * 300 + 50;
};

export type UseTimerOptions = {
  scale?: ScaleFunction;
};
export const useTimer = ({ scale = defaultScale }: UseTimerOptions = {}) => {
  const tidRef = useRef<number>();
  const stop = useCallback(() => {
    window.clearTimeout(tidRef.current);
  }, []);
  const start = useCallback(
    (callback: (e: Event) => void) => {
      stop();
      const timestamp = Date.now();
      const tick = () => {
        const now = Date.now();
        const dt = now - timestamp;
        const timeout = scale(dt);
        const e = new Event('tick', { cancelable: true });
        callback(e);
        if (e.defaultPrevented) {
          return;
        }
        tidRef.current = window.setTimeout(tick, timeout);
      };
      tick();
    },
    [scale, stop]
  );
  return { stop, start };
};
